import { render } from "./ClinicalStudies.vue?vue&type=template&id=f53f24a2&scoped=true"
import script from "./ClinicalStudies.vue?vue&type=script&lang=js"
export * from "./ClinicalStudies.vue?vue&type=script&lang=js"

import "./ClinicalStudies.vue?vue&type=style&index=0&id=f53f24a2&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3442\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53f24a2"]])

export default __exports__